import { useSupabaseLoader } from "../../../server/supabase/hooks";
import { useKeptWhileReloading } from "./use-kept-while-reloading";

import type { KeptState } from "./use-kept-while-reloading";

/**
 * Surveys that haven't been archived (archiving sets `deleted_at`), open or closed. Counted again
 * when `refreshKey` changes, keeping the last count meanwhile.
 */
export function useSurveyCount(refreshKey: number): KeptState<number> {
  const loaded = useSupabaseLoader(
    async ({ supabase, account_id }) => {
      const { count, error } = await supabase
        .from("survey")
        .select("id", { count: "exact", head: true })
        .eq("account_id", account_id)
        .is("deleted_at", null);
      if (error) throw error;

      return count ?? 0;
    },
    [refreshKey],
  );

  return useKeptWhileReloading(loaded);
}
